import {Injectable} from '@angular/core';
import {ModalService} from '../../common/component/modal/modal-service.service';
import {DigitalPlanPrintModalComponent} from './digital-plan-print-modal.component';

@Injectable({
    providedIn: 'root'
})
export class DigitalPlanPrintModalService extends ModalService {
    showModal() {
        this.createModalComponent(DigitalPlanPrintModalComponent);
        const modalComponentInstance = this.modalComponentRef.instance as DigitalPlanPrintModalComponent;
        this.showModalComponent();
        return modalComponentInstance.modalClosed;
    }
}
